import { NgModule } from "@angular/core";
import { CamModalModule } from "@modules/+new/custody_account/features/cam-modal/cam-modal.module";
import { AnnouncementModalComponent } from "./components/announcement-modal/announcement-modal.component";
import { ModalGuardService } from "./services/modal-guard.service";
import { NotFoundModalComponent } from "./components/not-found-modal/not-found-modal.component";
import { LoadingScreenComponent } from "./components/loading-screen/loading-screen.component";
import { OfflineModalComponent } from "./components/offline-modal/offline-modal.component";
import { Aml5ModalComponent } from "./components/aml5-modal/aml5-modal.component";
import { CryptowalletDetailsComponent } from "./components/wallet-edit/wallet-details/cryptowallet-details.component";
import { WalletRenameComponent } from "./components/wallet-edit/wallet-rename/wallet-rename.component";
import { AnnouncementCardComponent } from "./components/announcement-card/announcement-card.component";
import { InsufficientTradableAmountModalComponent } from "./components/insufficient-tradable-amount-modal/insufficient-tradable-amount-modal.component";
import { TransactionModule } from "../transaction/transaction.module";
import { FilterModule } from "./components/filters/filter.module";
import { TradableChartModule } from "./components/tradable-chart/tradable-chart.module";
import { PlatformLocation } from "@angular/common";
import { MandateListModalComponent } from "./components/mandate-list-modal/mandate-list-modal.component";
import { AuthModule } from "bp-authorization-lib";
import { ActionButtonModule } from "../action-buttons/action-button.module";
import { BlockpitTaxModalComponent } from "./components/blockpit-tax-modal/blockpit-tax-modal.component";
import { OnfidoModule } from "../onfido/onfido.module";
import { Security2faModule } from "../shared/modals/security-2fa-modal/security-2fa.module";
import { PricewatchAddModule } from "../shared/modals/pricewatch-add-modal/pricewatch-add.module";
import { ProfileModule } from "./components/profile/profile.module";
import { appRouting } from "../../routing";
import { TilesModule } from "./components/tiles/tiles.module";
import { TradableToViewModule } from "./components/tradable-to-view-item/tradable-to-view.module";
import { StepSummaryModule } from "./components/step-summary/step-summary.module";
import { PayoutModule } from "./components/payout/payout.module";
import { StocksModule } from "./components/stocks/stocks.module";
import { PasswordValidationModule } from "./components/password-validation/password-validation.module";
import { ContactModule } from "./components/contact/contact.module";
import { VerificationCommonModule } from "./components/verification-common/verification-common.module";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { InfiniteScrollingModule } from "../shared/components/infinite-scrolling/infinite-scrolling/infinite-scrolling.module";
import { WINDOW_PROVIDERS } from "@main-services/window.service";
import { WalletModalComponent } from "./components/wallet-modal/wallet-modal.component";
import { CryptoWalletAddressComponent } from "./components/crypto-wallet-address/crypto-wallet-address.component";
import { FiatWalletDetailsComponent } from "./components/fiat-wallet-details/fiat-wallet-details.component";
import { WithdrawalLockComponent } from "./components/withdrawal-lock/withdrawal-lock.component";
import { LegalSettingsComponent } from "./components/legal-settings/legal-settings.component";
import { SepaQrTileComponent } from "./components/sepa-qr-tile/sepa-qr-tile.component";
import { RewardClaimModalComponent } from "./components/rewards";
import { CryptoQRComponent } from "./components/crypto-qr/crypto-qr.component";
import { AddWatchListModalComponent } from "@modules/main/components/add-watchlist-modal/add-watchlist-modal.component";
import { UserComponent } from "./components/user/user.component";
import { LegalAcceptanceComponent } from "./components/legal-acceptance-modal/legal-acceptance.component";
import { PaymentSuccessModalComponent } from "./components/payment-successfull-modal/payment-success-modal.component";
import { FiatWalletQrModalComponent } from "./components/fiat-wallet-qr-modal/fiat-wallet-qr-modal.component";
import { QrModalComponent } from "./components/qr-modal/qr-modal.component";
import { ModalService } from "@core-services/modal.service";
import { CoreModule } from "../core/core.module";
import { Best2ModalComponent } from "./components/best2-modal/best2-modal.component";
import { TradableYouOwnModalComponent } from "./components/tradable-you-own-modal/tradable-you-own-modal.component";
import { InstantTradeBonusModule } from "@modules/shared/components/instant-trade-bonus/instant-trade-bonus.module";
import { StakingModule } from "@modules/staking/staking.module";
import { SepaQrNewComponent } from "@modules/main/components/sepa-qr-new/sepa-qr-new.component";
import { SepaQrTileNewComponent } from "./components/sepa-qr-new/sepa-qr-tile-new/sepa-qr-tile-new.component";
import { FiatDepositRemindModalComponent } from "./components/fiat-deposit-remind-modal/fiat-deposit-remind-modal.component";
import { TradeModule } from "@modules/trade/trade.module";
import { PaymentsEntryModule } from "@modules/+new/payments/payments-entry.module";
import { PortfolioEntryModalModule } from "@modules/portfolio/modal/portfolio-entry-modal.module";
import { LaunchpadRoutingModule } from "@modules/launchpad/features/launchpad-page/launchpad-routing.module";
import { GlobalWarningComponent } from "./components/global-warning/global-warning.component";
import { MultichainContactFormComponent } from "./components/multichain-contact/multichain-contact-form/multichain-contact-form.component";
import { MultichainContactAddressFormComponent } from "./components/multichain-contact/multichain-contact-address-form/multichain-contact-address-form.component";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";
import { RudderstackAnalyticsClient } from "@main-services/rudderstack.service";

const entryComponents = [
	RewardClaimModalComponent,
	MandateListModalComponent,
	CryptowalletDetailsComponent,
	WalletRenameComponent,
	AnnouncementModalComponent,
	AnnouncementCardComponent,
	OfflineModalComponent,
	Aml5ModalComponent,
	Best2ModalComponent,
	InsufficientTradableAmountModalComponent,
	FiatWalletQrModalComponent,
	WalletModalComponent,
	CryptoQRComponent,
	NotFoundModalComponent,
	QrModalComponent,
	LegalAcceptanceComponent,
	WithdrawalLockComponent,
	LoadingScreenComponent,
	BlockpitTaxModalComponent,
	AddWatchListModalComponent,
	TradableYouOwnModalComponent
];

const declarationComponents = [
	FiatWalletDetailsComponent,
	UserComponent,
	SepaQrTileComponent,
	SepaQrNewComponent,
	SepaQrTileNewComponent,
	CryptoWalletAddressComponent,
	LegalSettingsComponent,
	PaymentSuccessModalComponent,
	FiatDepositRemindModalComponent,
	GlobalWarningComponent
];

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
	interface Window {
		rudderanalytics?: RudderstackAnalyticsClient;
		analytics?: any;
	}
}
/* eslint-enable @typescript-eslint/no-explicit-any */

@NgModule({
	imports: [
		appRouting,
		OnfidoModule,
		TradableChartModule,
		FilterModule,
		ActionButtonModule,
		CoreModule,
		Security2faModule,
		TransactionModule,
		AuthModule,
		PricewatchAddModule,
		VerificationCommonModule,
		ProfileModule,
		TilesModule,
		TradableToViewModule,
		StepSummaryModule,
		PayoutModule,
		StocksModule,
		PasswordValidationModule,
		ContactModule,
		ScrollingModule,
		InfiniteScrollingModule,
		InstantTradeBonusModule,
		TradeModule,
		StakingModule,
		PaymentsEntryModule,
		PortfolioEntryModalModule,
		CamModalModule,
		LaunchpadRoutingModule,
		TermsAndConditionsUpdatesModule
	],
	declarations: [
		...entryComponents,
		...declarationComponents,
		MultichainContactFormComponent,
		MultichainContactAddressFormComponent
	],
	exports: [...entryComponents, ...declarationComponents],
	providers: [
		ModalGuardService,
		{ provide: "ModalGuardService", useClass: ModalGuardService },
		WINDOW_PROVIDERS,
		{
			provide: ModalService,
			useClass: ModalService,
			useFactory: ModalGuardService.guardedModalServiceFactory,
			deps: [PlatformLocation, ModalGuardService]
		}
	]
})
export class MainModule {}
